var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-chip-group', {
    staticClass: "ma-n4",
    attrs: {
      "multiple": ""
    }
  }, [_vm._l(_vm.value, function (file, i) {
    return [_c('v-chip', _vm._b({
      key: i,
      staticClass: "ma-4",
      attrs: {
        "outlined": "",
        "large": "",
        "label": "",
        "close": ""
      },
      on: {
        "click:close": function clickClose($event) {
          return _vm.pull(file);
        }
      }
    }, 'v-chip', _vm.makeChipAttrs(file), false), [_c('span', [_vm._v(_vm._s(file.name))])])];
  }), _c('v-file-btn', {
    staticClass: "ma-4 pa-0",
    attrs: {
      "tag": "v-chip",
      "outlined": "",
      "large": "",
      "label": "",
      "width": "32",
      "min-width": "32",
      "height": "32"
    },
    on: {
      "input": _vm.push
    },
    model: {
      value: _vm.temp,
      callback: function callback($$v) {
        _vm.temp = $$v;
      },
      expression: "temp"
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }